import fleetApi from "@/lib/fleetApi";

const DONE = /complete|cancel|no.?show/i;
const cache = new Map();

export const driverOpenTrips = (driverId) => {
  if (!driverId) return Promise.resolve([]);
  if (!cache.has(driverId)) {
    const p = fleetApi.get(`/trips?driver_id=${encodeURIComponent(driverId)}&limit=5000`)
      .then((r) => (r.data || []).filter((t) => !DONE.test(t.status || "")))
      .catch(() => { cache.delete(driverId); return []; });
    cache.set(driverId, p);
  }
  return cache.get(driverId);
};

// unfinished trips scheduled at or before the given pickup (excluding the trip itself)
export const unfinishedBefore = (open, trip) => open.filter((t) => t.id !== trip?.id
  && (!trip?.scheduled_pickup || !t.scheduled_pickup || new Date(t.scheduled_pickup) <= new Date(trip.scheduled_pickup)));

export const clearDriverLoad = () => cache.clear();
